<template>
  <div v-if="displayInfo" id="contact-details" class="service-contact py-4 px-2">
    <h3 class="h5">Service contact details</h3>
    <b-list-group>
      <b-list-group-item v-if="dataItem.url" id="service-website" class="p-0 border-0 bg-light">
        <b-icon icon="globe" class="mr-2"></b-icon>
        <a :href="dataItem.url" itemprop="url">{{ dataItem.name }} website</a>
      </b-list-group-item>
      <b-list-group-item v-if="dataItem.email" id="service-email" class="p-0 border-0 bg-light">
        <b-icon icon="envelope-fill" class="mr-2"></b-icon>
        <a :href="'mailto:' + dataItem.email" itemprop="email">{{ dataItem.email }}</a>
      </b-list-group-item>
    </b-list-group>
    <b-list-group v-if="dataItem.contacts && dataItem.contacts.length > 0">
      <b-list-group-item
        v-for="(contact, cIx) in dataItem.contacts"
        id="service-phone"
        :key="cIx"
        class="p-0 border-0 bg-light"
      >
        <span v-for="(phone, pIx) in contact.phones" :key="pIx">
          <b-icon icon="telephone-fill"></b-icon>
          <span> {{ contact.title }} {{ contact.name }}</span>
          <a :href="'tel:' + phone.number" itemprop="telephone" class="ml-2">{{ phone.number }}</a>
        </span>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
import slugg from '@/filters/sluggify.js'
import trunc from '@/filters/trunc.js'

export default {
  name: 'BasicInfo',
  filters: {
    slugg,
    trunc,
  },
  props: {
    dataItem: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    displayInfo() {
      if (
        (this.dataItem.url && this.dataItem.url.length > 1) ||
        (this.dataItem.email && this.dataItem.email.length > 1) ||
        (this.dataItem.contacts && this.dataItem.contacts[0] && this.dataItem.contacts[0].phone)
      )
        return true
      return false
    },
  },
}
</script>
